import { expVal } from '@atlassian/jira-feature-experiments';

export const PLACEHOLDER_TEMPLATE_CO_USE_EXPERIMENT_ID = 'confluence_template_placeholder';
export const PLACEHOLDER_TEMPLATE_CO_USE_AA_EXPERIMENT_ID =
	'aa_confluence_placeholder_template_onboarding' as const;

export const TEST_IDS = {
	addLinkButton: 'issue-view-common-views.button.icon-button.placeholder-template-co-use',
	mainContainer: 'placeholder-template-main-container',
	header: 'placeholder-template-header',
	adMenuButton: 'placeholder-template-ad-menu-button',
} as const;

// ====== Function for retrieving cohort =======
export const evaluateConfluenceTemplatePlaceholder = () => {
	const exp = expVal<'not-enrolled' | 'control' | 'variation'>(
		'confluence_template_placeholder',
		'cohort',
		'not-enrolled',
	);
	return exp;
};
